import { capture } from "../observability/capture.js";
/**
 * Platform logging (console / native logger) is injected; analytics uses the module-level
 * backends wired by setBackends() — same pattern as web PlatformObservability + capture().
 */
export function createModuleBackedPlatformObservability(params) {
    return {
        error: params.error,
        warn: params.warn,
        isDev: params.isDev,
        capture: (event, properties) => capture(event, properties),
    };
}
